import React, { memo, useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import DatasetTableItem from './DatasetTableItem';
import Th from '../../../../../components/common-table/components/Th';
import Tr from '../../../../../components/common-table/components/Tr';
import ThCheckbox from '../../../../../components/common-table/components/ThCheckbox';
import { selectAllDatasets } from '../../../../../redux/create-sonar/createSonarReducer';
import VirtualizedTable from '../../../../../components/common-table/VirtualizedTable';
import { deleteFromDataset } from '../../../../../redux/create-sonar/createSonarActions';
import ConfirmationModal from '../../../../../components/confirmation-modal/ConfirmationModal';
import DeleteLabel from '../../../../projects-list/components/DeleteLabel';

import scss from '../SonarCreationForm.module.scss';

const DatasetTable = ({ onEdit }) => {
  const { t } = useTranslation('projects');
  const dispatch = useDispatch();

  const [selectedItem, setSelectedItem] = useState(null);

  const dataset = useSelector((state) => state.createSonar.dataset);
  const isDatasetLoading = useSelector((state) => state.createSonar.isDatasetLoading);
  const isAllDatasetSelected = useSelector((state) => state.createSonar.isAllDatasetSelected);

  const handleSelectAll = useCallback(() => {
    dispatch(selectAllDatasets());
  }, [dispatch]);

  const handleDeleteSingleItem = () => {
    dispatch(deleteFromDataset([selectedItem.id]));
    setSelectedItem(null);
  };

  const handleOpenDeleteModal = (item) => {
    setSelectedItem(item);
  };

  const handleCloseModal = () => {
    setSelectedItem(null);
  };

  return (
    <div className={scss.tableWrapper}>
      <VirtualizedTable
        content={dataset}
        isLoading={isDatasetLoading}
        renderBody={(item) => (
          <DatasetTableItem key={item.count} item={item} onEdit={onEdit} onDelete={handleOpenDeleteModal} />
        )}>
        <Tr extraClasses={scss.datasetTableHeader}>
          <ThCheckbox selected={isAllDatasetSelected} onSelect={handleSelectAll} />
          <Th extraClasses='cell-rank'>#</Th>
          <Th isLeft>{t('company')}</Th>
          <Th isLeft>Facebook</Th>
          <Th isLeft>Instagram</Th>
          <Th isLeft>Youtube</Th>
          {/* <Th isLeft>Trustpilot</Th> */}
          <Th isLeft>Twitter</Th>
          <Th isLeft>Tik-Tok</Th>
          {/* <Th isLeft>LinkedIn</Th> */}
          <Th isLeft extraClasses={scss.actionCell} />
        </Tr>
      </VirtualizedTable>

      <ConfirmationModal
        isOpen={selectedItem}
        onClose={handleCloseModal}
        onCancel={handleCloseModal}
        onConfirm={handleDeleteSingleItem}
        subLabel={<DeleteLabel name={selectedItem?.brandCompany || selectedItem?.domain} />}
      />
    </div>
  );
};

export default memo(DatasetTable);
